import Chart from 'react-apexcharts';

const DonutChart = ({ title, subtitle, series, optionLabels, colors }) => {
    const defaultColors = ['#137dc5', '#50c878', '#facf39', '#e4954b', '#7ab3c9'];

    return (
        <Chart
            type="donut"
            height={360}
            width={'100%'}
            series={series ?? []}
            labels={{
                show: false,
                name: {
                    show: true,
                },
            }}
            options={{
                labels: optionLabels ?? [''],
                legend: {
                    show: true,
                    position: 'right',
                },
                colors: colors?.length ? colors : defaultColors,
                title: {
                    text: title,
                    align: 'left',
                    style: {
                        fontSize: '16px',
                        color: '#131313',
                        fontFamily: 'Segoe UI',
                        fontWeight: 650,
                    },
                },
                subtitle: {
                    text: subtitle,
                    align: 'left',
                    style: {
                        fontSize: '12px',
                        color: '#131313',
                        fontFamily: 'Segoe UI',
                        fontWeight: 500,
                    },
                },
            }}
        />
    );
};

export default DonutChart;
